import { render, staticRenderFns } from "./StatisticsOverview.vue?vue&type=template&id=48271186&scoped=true&"
import script from "./StatisticsOverview.vue?vue&type=script&lang=js&"
export * from "./StatisticsOverview.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=48271186&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48271186",
  null
  
)

export default component.exports